module.exports = __webpack_public_path__ + "static/media/bancontact_website.bf03b8fa.webp";